import { useEffect } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import Icon from "icons/Suspicious";
import Profit from "icons/profits";
import VoidIcon from "icons/void";
import ReportIcon from "icons/Report";
import ForecastIcon from "icons/Forecast";
import { FaFileDownload } from "react-icons/fa";
import RefreshIcon from '@mui/icons-material/Refresh';
import PropTypes from "prop-types";
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography,
} from "@material-ui/core";
import MoneyIcon from "@material-ui/icons/Money";
import {
  AlertCircle as AlertCircleIcon,
  BarChart as BarChartIcon,
  Lock as LockIcon,
  Settings as SettingsIcon,
  ShoppingBag as ShoppingBagIcon,
  User as UserIcon,
  UserPlus as UserPlusIcon,
  Users as UsersIcon,
} from "react-feather";
import NavItem from "./NavItem";
import { useSelector } from "react-redux";

const user = {
  avatar: "/static/images/avatars/avatar_12.jpg",
};

const items = [
  {
    href: "/app/salesPreset",
    icon: BarChartIcon,
    title: "Dashboard",
  },
   {
    href: "/app/updateTransactions",
    icon: RefreshIcon,
    title: "Update Transactions",
  },
  {
    href: "/app/reports",
    icon: ReportIcon,
    title: "Budget Reports",
  },
  {
    href: "/app/susTransactions",
    icon: Icon,
    title: "Suspicious",
  },
  {
    href: "/app/voidTransactions",
    icon: VoidIcon,
    title: "Void",
  },
  {
    href: "/app/profitPreset",
    icon: Profit,
    title: "Profit",
  },
  {
    href: "/app/products",
    icon: ShoppingBagIcon,
    title: "Products",
  },
  {
    href: "/app/seasonalProductSales",
    icon: MoneyIcon,
    title: "Seasonal Sales",
  },
  {
    href: "/app/seasonalForecast",
    icon: ForecastIcon,
    title: "Seasonal Forecast",
  },
  {
    href: "/app/fileUpload",
    icon: MoneyIcon,
    title: "Budget",
  },
  {
    href: "/app/newBudget",
    icon: MoneyIcon,
    title: "NewBudget",
  },

  {
    href: "/app/account",
    icon: UserIcon,
    title: "Account",
  },
  {
    href: "/app/downloads",
    icon: FaFileDownload,
    title: "Downloads",
  },

  {
    href: "/404",
    icon: AlertCircleIcon,
    title: "Error",
  },
];

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const userlogin = useSelector((state) => state.user);
  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          p: 2,
        }}
      >
        <Avatar
          component={RouterLink}
          src={user.avatar}
          sx={{
            cursor: "pointer",
            width: 64,
            height: 64,
          }}
          to="/app/account"
        />
        <Typography color="textPrimary" variant="h8" sx={{ pt: 1 }}>
          {userlogin.name}
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ p: 2 }}>
        <List>
          {items.map((item) => (
            <NavItem
              href={item.href}
              key={item.title}
              title={item.title}
              icon={item.icon}
            />
          ))}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          backgroundColor: "background.default",
          m: 2,
          p: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            pt: 2,
          }}
        ></Box>
      </Box>
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256,
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: "calc(100% - 64px)",
            },
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => null,
  openMobile: false,
};

export default DashboardSidebar;
